module.exports = __webpack_public_path__ + "static/img/point_icon_01.f6951451.svg";